import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// // // LIST ALL Medias
export const mediasList = (params = {}) => Http.get('/showcase-media-partners', { params })

export const mediaCreate = (params = '') => Http.post('/showcase-media-partners', params)
export const mediaByID = (params = '') => Http.get(`/showcase-media-partners/${params}?include=showcase,partner`)
export const mediaUpdate = (params = '') => Http.put(`/showcase-media-partners/${params.id}`, params)
export const mediaDestroy = (params = '') => Http.delete(`/showcase-media-partners/${params.id}`)
